import { render, staticRenderFns } from "./GridPoints.vue?vue&type=template&id=64a2495a&scoped=true&"
import script from "./GridPoints.vue?vue&type=script&lang=js&"
export * from "./GridPoints.vue?vue&type=script&lang=js&"
import style0 from "./GridPoints.vue?vue&type=style&index=0&id=64a2495a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2495a",
  null
  
)

export default component.exports